"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readMetadata = readMetadata;
exports.readSelectList = readSelectList;
exports.readSubForm = readSubForm;
exports.readParseDate = readParseDate;
const core_api_1 = require("@ikegps/core-api");
const index_1 = require("../index");
const form_subform_1 = require("../subform/form.subform");
function readMetadata(target, metadata) {
    if (metadata == null) {
        return;
    }
    if (metadata.import != null) {
        target.metadata.setImportType(metadata.import.type, metadata.import.version);
    }
    if (metadata.status != null) {
        const statusField = target.getField(metadata.status.field);
        if (statusField == null ||
            !(statusField.type === core_api_1.IkeFieldType.NESTED_LIST || statusField.type === core_api_1.IkeFieldType.SELECT_LIST)) {
            throw new Error('Unable to find status field for form: ' + target.revision + ' status:' + metadata.status.field);
        }
        target.metadata.setStatusField(statusField);
    }
    if (metadata.mapColor != null) {
        const mapColorField = target.getField(metadata.mapColor.field);
        if (mapColorField == null ||
            !(mapColorField.type === core_api_1.IkeFieldType.NESTED_LIST || mapColorField.type === core_api_1.IkeFieldType.SELECT_LIST)) {
            throw new Error('Unable to find status field for form: ' + target.revision + ' mapColor:' + metadata.mapColor.field);
        }
        target.metadata.setMapColorField(mapColorField);
    }
    if (metadata.address_lookup != null) {
        const addressLookupField = target.getField(metadata.address_lookup.address.field);
        if (addressLookupField == null ||
            !(addressLookupField.type === core_api_1.IkeFieldType.TEXT || addressLookupField.type === core_api_1.IkeFieldType.NUMBER)) {
            throw new Error('Unable to find address lookup for form ' +
                target.revision +
                ' address_lookup: ' +
                metadata.address_lookup.address.field);
        }
        target.metadata.setAddressLookupField(addressLookupField);
    }
    else {
        target.metadata.setAddressLookupField(null);
    }
    Object.keys(metadata).forEach((key) => {
        if (key === 'import' || key === 'status' || key === 'mapColor') {
            return;
        }
        target.metadata.setOption(key, metadata[key]);
    });
}
function getProviders(field) {
    const providers = [];
    // No valid providers nothing to serialize
    if (field.providers == null || field.providers.length === 0) {
        return undefined;
    }
    // Convert all string providers to their respective object mode
    for (const provider of field.providers) {
        if (typeof provider !== 'string') {
            providers.push(provider);
            continue;
        }
        // Default provider object for existing span
        if (provider === core_api_1.IkeProviderType.EXISTING_SPAN) {
            providers.push(index_1.IkeCalcExistingSpanLegacyProvider);
        }
    }
    if (providers.length === 0) {
        return undefined;
    }
    return providers;
}
function readSelectList(target, field) {
    if (field.options == null || !Array.isArray(field.options)) {
        return;
    }
    for (let i = 0; i < field.options.length; i++) {
        const opt = field.options[i];
        target.Mutator.option(opt, i);
    }
}
function readSubForm(target, fromSchema, allFields = {}) {
    for (const field of fromSchema.fields) {
        /** Sometimes we get duplicate fieldIds these are not valid and need to be removed. */
        if (allFields[field.name]) {
            continue;
        }
        const targetField = target.createField(field.type, {
            id: field.name,
            displayName: field.displayname,
            cloneable: field.cloneable,
            title: field.title,
            subtitle: field.subtitle,
            adminOnly: field.adminOnly,
            annotationLabelFieldId: field.annotationLabelFieldId,
            clearanceThresholdInMeters: field.clearanceThresholdInMeters,
            providers: getProviders(field),
            collector: field.collector,
            required: field.required,
            locked: field.locked,
        });
        allFields[field.name] = true;
        if (form_subform_1.FormModelFieldSubForm.isSubForm(targetField)) {
            const schema = field.schema;
            if (schema == null) {
                continue;
            }
            targetField.Mutator.label(schema.label);
            if (!Array.isArray(schema.fields)) {
                continue;
            }
            readSubForm(targetField, schema, allFields);
        }
        else if (index_1.FormModelFieldNestedList.isNestedList(targetField)) {
            targetField.Mutator.init(field.options);
        }
        else if (index_1.FormModelFieldSelectList.isSelectList(targetField)) {
            readSelectList(targetField, field);
        }
    }
    if (fromSchema.subformType === 'span' && fromSchema.subformSpanTypeState) {
        target.Mutator.span.setFieldReferences(fromSchema.subformSpanTypeState.vectorFieldId, fromSchema.subformSpanTypeState.typeFieldId, fromSchema.subformSpanTypeState.midSpanIkePhotoFieldId);
    }
    else if (fromSchema.subformType === 'pole') {
        target.Mutator.poleType();
    }
    return null;
}
function readParseDate(isoString) {
    if (isoString == null) {
        return null;
    }
    return new Date(isoString);
}
//# sourceMappingURL=db.v1.read.js.map